// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_1B629","Container":"_2GtbP","Navigation":"_3RMkW","NavigationItem":"_3yhp4","NavigationItemLink":"_EI_cG","NavigationItemLinkActive":"_2dI3N","BoxOne":"_3zaFB","BoxTwo":"_2bDAX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelDetail.scss
// module id = 940
// module chunks = 0